/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { CalendarSummaryViewCalendarSummaryFragmentDoc } from './CalendarSummaryView/CalendarSummaryView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CalendarStatus =
  | 'ACTIVE'
  | 'INACTIVE';

export type FetchCalendarSummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCalendarSummariesQuery = { currentEntrance: { calendarSummaries: Array<{ guid: string, status: Types.CalendarStatus, publicTitle: string, privateTitle: string | null, description: string | null, createdAt: TimeString, assignedStaffs: Array<{ displayName: string, guid: string, priority: number | null }> }> } };

export type CalendarSettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarSettingsPageQuery = { uiControl: { editOkanekoCalendarSetting: boolean } };


export const FetchCalendarSummariesDocument = gql`
    query FetchCalendarSummaries {
  currentEntrance {
    calendarSummaries {
      ...CalendarSummaryViewCalendarSummary
    }
  }
}
    ${CalendarSummaryViewCalendarSummaryFragmentDoc}`;

/**
 * __useFetchCalendarSummariesQuery__
 *
 * To run a query within a Vue component, call `useFetchCalendarSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCalendarSummariesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCalendarSummariesQuery();
 */
export function useFetchCalendarSummariesQuery(options: VueApolloComposable.UseQueryOptions<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables>(FetchCalendarSummariesDocument, {}, options);
}
export function useFetchCalendarSummariesLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables>(FetchCalendarSummariesDocument, {}, options);
}
export type FetchCalendarSummariesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCalendarSummariesQuery, FetchCalendarSummariesQueryVariables>;
export const CalendarSettingsPageDocument = gql`
    query CalendarSettingsPage {
  uiControl {
    editOkanekoCalendarSetting
  }
}
    `;

/**
 * __useCalendarSettingsPageQuery__
 *
 * To run a query within a Vue component, call `useCalendarSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarSettingsPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarSettingsPageQuery();
 */
export function useCalendarSettingsPageQuery(options: VueApolloComposable.UseQueryOptions<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables>(CalendarSettingsPageDocument, {}, options);
}
export function useCalendarSettingsPageLazyQuery(options: VueApolloComposable.UseQueryOptions<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables>(CalendarSettingsPageDocument, {}, options);
}
export type CalendarSettingsPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CalendarSettingsPageQuery, CalendarSettingsPageQueryVariables>;